import { HttpRoutes } from 'utils/constant';

import { format, stringStartWithMulti } from '../utils';

import Service from './service';

/**
 * @param {Number} companyId
 */
const getCompanyDetails = async (companyId) => {
  try {
    if (!companyId) {
      throw new Error(
        'error while fetch ',
        `${HttpRoutes.getCompanyDataById} - companyId is missing`
      );
    }
    const companyDetails = await Service.post(HttpRoutes.getCompanyDataById, { companyId });
    if (companyDetails && companyDetails.data) {
      return companyDetails.data || {};
    }
    throw new Error('error while fetch ', HttpRoutes.getCompanyDataById);
  } catch (e) {
    return e;
  }
};

/**
 * @param {Number} companyId
 */
const getCompanyDisplayMode = async (companyId) => {
  try {
    const companyDisplayMode = await Service.get(
      format(HttpRoutes.getCompanyDisplayMode, { companyId })
    );
    if (companyDisplayMode && companyDisplayMode.data) {
      return companyDisplayMode.data[0].hiddenSections || [];
    }
    throw new Error('error while fetch ', format(HttpRoutes.getCompanyDisplayMode, { companyId }));
  } catch (e) {
    return [];
  }
};

/**
 *
 * @param {Array<Number>} companyIds
 */
const getCompanyInfoByIds = async (companyIds = []) => {
  try {
    const companyInfos = await Service.post(HttpRoutes.getCompanyInfoByIds, { companyIds });
    if (companyInfos && companyInfos.data) {
      return companyInfos.data;
    }
    throw new Error('error while fetch ', HttpRoutes.getCompanyInfoById);
  } catch (e) {
    return e;
  }
};

/**
 *
 * @param {Array<Number>} companyIDs
 */
const getCompaniesJobsCount = async (companyIDs = []) => {
  try {
    const companiesJobsCount = await Service.post(HttpRoutes.getCompaniesJobsCount, { companyIDs });
    if (companiesJobsCount && companiesJobsCount.data && companiesJobsCount.data.result) {
      return companiesJobsCount.data.result;
    }
    throw new Error('error while fetch ', HttpRoutes.getCompaniesJobsCount);
  } catch (e) {
    return e;
  }
};

const getCompanyCategoryNameDisplay = (category) =>
  stringStartWithMulti(category, ['best', 'most'], true) ? category : `Best ${category}`;

const getCompanyCategoryUrlPart = (category) =>
  stringStartWithMulti(category, ['best', 'most'], true) ? category : `best-${category}`;

const getTopCompaniesSalaryEstimatesBySocCode = async (data) => {
  try {
    const response = await Service.get(
      format(HttpRoutes.getTopCompaniesSalaryEstimatesBySocCode, data)
    );

    if (response && response.data) {
      return response.data;
    }

    throw new Error('error while fetch ', HttpRoutes.getTopCompaniesSalaryEstimatesBySocCode);
  } catch (e) {
    return e;
  }
};

const getCompaniesAvgSalaries = async (payload) => {
  try {
    const res = await Service.post(HttpRoutes.getCompaniesAverageSalaries, payload);
    if (res && res.data) {
      return res.data;
    }

    throw new Error('error while fetch ', HttpRoutes.getCompaniesAverageSalaries);
  } catch (e) {
    return e;
  }
};

const getCompetitorJobTitleSalaries = async (payload) => {
  try {
    const res = await Service.post(HttpRoutes.getCompetitorJobTitleSalaries, payload);
    if (res && res.data) {
      return res.data;
    }

    throw new Error('error while fetch ', HttpRoutes.getCompetitorJobTitleSalaries);
  } catch (e) {
    return e;
  }
}

/**
 * @param {Object} payload
 * @param {string|number} payload.companyID
 * @param {number} payload.rating
 * @param {string} payload.companyURL
 * @param {boolean} payload.bestReviewsFirst
 * @param {number} payload.noOfItems
 * @param {number} payload.start
 * @param {string?} payload.category
 * @returns
 */
const getCompanyReviewsByRating = async (payload) => {
  try {
    const res = await Service.post(HttpRoutes.getCompanyReviewsByRating, payload);

    if (res && res.data) {
      return res.data;
    }

    throw new Error('error while fetch ', HttpRoutes.getCompanyReviewsByRating);
  } catch (error) {
    return error;
  }
};

export const companyService = {
  getCompanyDetails,
  getCompanyDisplayMode,
  getCompanyInfoByIds,
  getCompanyCategoryNameDisplay,
  getCompanyCategoryUrlPart,
  getCompaniesJobsCount,
  getTopCompaniesSalaryEstimatesBySocCode,
  getCompaniesAvgSalaries,
  getCompetitorJobTitleSalaries,
  getCompanyReviewsByRating,
};
